<template>
  <drawer-facade
    v-model="model"
    class="drawer-right"
    @close="(event) => $emit('close', event)"
  >
    <template #closeIcon>
      <drawer-close/>
    </template>
    <template #default>
      <slot></slot>
    </template>
  </drawer-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import DrawerFacade from '@/lib/ant-design-vue/components/DrawerFacade.vue';
  import DrawerClose from './DrawerClose.vue';

  const model = defineModel();

  defineEmits(['close'])
</script>

<style lang="scss">
  .ant-drawer-content-wrapper,
  .drawer-right {
    border-radius: 20px 0px 0px 20px;
  }

  .drawer-right {
    .ant-drawer-header {
      border-bottom: none;
      padding: 0 !important;
    }

    .ant-drawer-close {
      left: -18px;
      margin-inline-end: 0;
      padding: 0;
      position: absolute;
      top: 37px;
    }

    .ant-drawer-body {
      padding: 119px 40px 40px;
    }
  }
</style>